{
    "GenericFooter_ServerErrorTitle": "Erreurs de validation",
    "GenericFooter_ValidationWarning": "Veillez à ce que tous les champs soient correctement remplis",
    "GenericFooter_ButtonHelpLabel": "Aide?",
    "GenericFooter_ButtonSubmitLabel": "Économiser",
    "GenericFooter_ButtonCancelLabel": "Annuler",
    "NAME": "GenericFooter"
}